module.exports = __webpack_public_path__ + "static/ss12.6702da26.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/projects/studysmart/ss/ss12.png
// module id = 1189
// module chunks = 81679748166845